$(document).ready(function () {

    //Stories Block
    var $storiesPagination = $('.stories-card__pagination');
    var $storiesCardsEl = $('.stories-card__featured-carousel-items');

    $storiesCardsEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $storiesPagination.text('');
        } else {
            $storiesPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $storiesCardsEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-light.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-light.svg" alt="next arrow"></div>',
    });

    // Client Feedback
    var $clientFeedbackPagination = $('.client-feedback__pagination');
    var $clientFeedbackEl = $('.client-feedback__slider-items');

    $clientFeedbackEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $clientFeedbackPagination.text('');
        } else {
            $clientFeedbackPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $clientFeedbackEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-light.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-light.svg" alt="next arrow"></div>',
    });

    //News Insights
    var $newsInsightsPagination = $('.js-news-insights-pagination');
    var $newsInsightsEl = $('.js-news-insights-slider');

    $newsInsightsEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $newsInsightsPagination.text('');
        } else {
            $newsInsightsPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

/*
    // Function to set all slides to the height of the tallest slide
    function setEqualHeight() {
        console.log('setEqualHeight()');
        var maxHeight = 0;

        // Find the maximum height of all slides
        $newsInsightsEl.find('.js-news-insights-slide').each(function () {
            var slideHeight = $(this).outerHeight();
            if (slideHeight > maxHeight) {

                console.log($(this));
                console.log('h', slideHeight);

                maxHeight = slideHeight;
            }
        });

        // Set all slides to the maximum height
        $newsInsightsEl.find('.js-news-insights-slide').css('height', maxHeight + 'px');
        $newsInsightsEl.find('.js-news-insights-slide .item-inner').css('height', maxHeight + 'px');
    }
*/

    $newsInsightsEl.slick({
        arrows: true,
        dots: true,
        centerMode: true,
        centerPadding: '100px',
        infinite: true,
        slidesToShow: 3,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    centerPadding: '150px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    });


    /*// Call the function after the slick slider is initialized
    setEqualHeight();

    // Optionally, call the function on window resize to maintain equal heights
    $(window).on('resize', function () {
        setEqualHeight();
    });*/

    // Case Studies
    triggerCaseStudiesCarousel();

    //Client list
    $('.js-client-list-slider').slick({
        infinite: true,
        speed: 300,
        arrows: false,
        dots: false,
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    autoplay: true,
                    autoplaySpeed: 2000, // Adjust the speed as needed
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    autoplay: true,
                    autoplaySpeed: 2000, // Adjust the speed as needed
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '70px',
                    autoplay: true,
                    autoplaySpeed: 2000, // Adjust the speed as needed
                }
            }
        ]
    });


    // Image slider
    var $sliderListPagination = $('.image-slider__pagination');
    var $sliderListEl = $('.slider-list');

    $sliderListEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $sliderListPagination.text('');
        } else {
            $sliderListPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $sliderListEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-light.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-light.svg" alt="next arrow"></div>',
    });

    // Quote slider no nav
    $('.quote-slider__no-nav').slick({
        infinite: true,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        slidesToShow: 1,
    });

    // Quote slider with nav
    var $quoteSliderListPagination = $('.quote-slider__pagination');
    var $quoteSliderListEl = $('.quote-slider__list');

    $quoteSliderListEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        // Check if pagination should be updated or hidden
        if (slick.$dots && slick.$dots[0].children.length > 1) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $quoteSliderListPagination.text(i + '/' + slick.$dots[0].children.length);
        } else {
            $quoteSliderListPagination.text('');
        }
    });

    $quoteSliderListEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        adaptiveHeight: true
    });


    // As seen
    $('.as-seen__list').slick({
        infinite: true,
        speed: 300,
        arrows: false,
        dots: false,
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '60px',
                }
            }
        ]
    });

    // Stats mobile slider
    var $statsPagination = $('.js-stats-pagination');
    var $statsCardsEl = $('.js-stats-list');
    const $resultsStatsEl = $('.js-results-stats');

    $statsCardsEl.add($resultsStatsEl).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $storiesPagination.text('');
        } else {
            $statsPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $statsCardsEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        mobileFirst: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    // Results block stats slider
    function initSlickResultsStats(width) {
        const $resultsStatsEl = $('.js-results-stats');
        if ($resultsStatsEl.hasClass('slick-initialized')) return;
        
        $resultsStatsEl.slick({
            infinite: true,
            speed: 300,
            arrows: true,
            dots: true,
            prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-light.svg" alt="prev arrow"></div>',
            nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-light.svg" alt="next arrow"></div>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: width,
                    settings: "unslick"
                },
            ]
        });
    }
    // Width breakpoint
    const resultsStatsmobileBreakpoint = 900;

    // Initialize the slider on load if window width is less than the breakpoint
    $(window).on('load', function () {
        if ($(window).width() < resultsStatsmobileBreakpoint) {
            initSlickResultsStats(resultsStatsmobileBreakpoint);
        }
    });

    // Initialise the slider on debounced resize event if window width is less than the breakpoint
    var debouncedInitSlickResultsStats = debounce(function () {
        if ($(window).width() < resultsStatsmobileBreakpoint) {
            initSlickResultsStats(resultsStatsmobileBreakpoint);
        }
    }, 250);
    $(window).on('resize', debouncedInitSlickResultsStats);


    // Staff List
    var $staffListEl = $('.staff-list__items');
    var $staffListPagination = $('.staff-list__pagination');

    $staffListEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $staffListPagination.text('');
        } else {
            $staffListPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $staffListEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 900,
                settings: "unslick"
            }
        ]
    });

    // Values list
    var $valuesListEl = $('.values-list__items');
    var $valuesListPagination = $('.values-list__pagination');

    $valuesListEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $valuesListPagination.text('');
        } else {
            $valuesListPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $valuesListEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 900,
                settings: "unslick"
            }
        ]
    });

    // How it works
    var $stepsListEl = $('.steps-list__items');
    var $stepsPagination = $('.steps-list__pagination');

    $stepsListEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.$dots[0].children.length == 1) {
            $stepsPagination.text('');
        } else {
            $stepsPagination.text(i + '/' + (slick.$dots[0].children.length));
        }
    });

    $stepsListEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 900,
                settings: "unslick"
            }
        ]
    });

    // Multisite slider — mobile only, auto-scrolls slowly, stops on interaction
    function initMultisiteSlider() {
        var $el = $('.js-multisite-slider');
        if ($el.hasClass('slick-initialized')) return;

        $el.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2500,
            speed: 1200,
            cssEase: 'ease-in-out',
            arrows: false,
            dots: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '32px',
            pauseOnHover: true,
            pauseOnFocus: true,
        });

        $el.on('swipe touchEnd', function () {
            $(this).slick('slickPause');
        });
    }

    var multisiteBreakpoint = 900;

    $(window).on('load', function () {
        if ($(window).width() < multisiteBreakpoint) {
            initMultisiteSlider();
        }
    });

    $(window).on('resize', debounce(function () {
        if ($(window).width() < multisiteBreakpoint) {
            initMultisiteSlider();
        }
    }, 250));
});

function triggerCaseStudiesCarousel() {
    var $caseStudiesEl = $('.case-studies__featured-carousel-items');

    $caseStudiesEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var $caseStudiesPagination = $($(this).prev());

        if (slick.$dots && slick.$dots[0].children.length > 1) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $caseStudiesPagination.text(i + '/' + slick.$dots[0].children.length);
        } else {
            $caseStudiesPagination.text('');
        }
    });

    $caseStudiesEl.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-light.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-light.svg" alt="next arrow"></div>',
    });
}